import pricing from '@/pricing'

const setCurrentUser = (state, payload) => {
  // eslint-disable-next-line global-require
  state.currentUser = {
    rememberSettings: {},
    ...payload,
  }
}

const setIsTokenValid = (state, payload) => {
  state.isTokenValid = payload
}

const setPlan = (state, payload) => {
  state.plan = pricing.getPlanByType(payload)
}

const updateCurrentUser = (state, payload) => {
  if (!state.currentUser || !state.currentUser.id) return
  state.currentUser = {
    ...state.currentUser,
    ...payload,
  }
}

export default {
  setCurrentUser,
  setIsTokenValid,
  setPlan,
  updateCurrentUser,
}
